// Service catalog. `image` is intentionally empty — the public site renders a
// branded illustrated placeholder until Dr. Biriș uploads custom photos via the
// admin panel (the override is merged in `useServices.js`).
export const SERVICES = [
  {
    slug: "profilaxie-igienizare",
    title: "Profilaxie și igienizare dentară",
    short: "Detartraj cu ultrasunete, periaj profesional și fluorizare — fundamentul unei sănătăți orale durabile.",
    image: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/tntjfhgv_IMG-20260701-WA0030.jpg",
    fit: "contain",
    icon: "sparkles",
    tone: "cream",
  },
  {
    slug: "tratamente-odontale",
    title: "Tratamente odontale",
    short: "Diagnostic și tratamentul cariilor cu materiale moderne, fizionomice, conform standardelor actuale.",
    image: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/q8j5otfw_file_000000003ac071fd96d31cf650322f72.png",
    fit: "contain",
    icon: "stethoscope",
    tone: "yellow",
  },
  {
    slug: "profilaxie-parodontala",
    title: "Profilaxie parodontală și igienizare profesională",
    short: "Măsuri de prevenție și igienizare profesională pentru menținerea sănătății țesuturilor de susținere: detartraj, Air-Flow, periaj profesional și instruirea pacientului privind igiena orală. Situațiile care necesită tratament parodontologic de specialitate sunt îndrumate către medicul parodontolog.",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_ro-dental-clinic/artifacts/q0cfb4j5_IMG-20260630-WA0007%281%29.jpg",
    fit: "contain",
    icon: "shield",
    tone: "green",
  },
  {
    slug: "reabilitare-orala",
    title: "Reabilitare orală cu proteze",
    short: "Proteze fixe, mobile și mobilizabile, realizate individualizat pentru funcționalitate și confort.",
    image: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/u9eogiig_file_0000000067c471f8b38542066193b8fe.png",
    fit: "contain",
    icon: "smile",
    tone: "pink",
    gallery: [
      {
        src: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/jfbhv3nf_IMG-20260701-WA0025.jpg",
        alt: "Protezele scheletate — indicații și contraindicații, soluția modernă pentru edentațiile parțiale — CMI. Dr. Biriș Cornelia · Ro-Dental Cluj-Napoca",
        caption: "Proteze scheletate",
      },
      {
        src: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/ojrga73x_IMG-20260701-WA0029.jpg",
        alt: "Proteze mobile acrilice — avantaje, tipuri și îngrijire — CMI. Dr. Biriș Cornelia · Ro-Dental Cluj-Napoca",
        caption: "Proteze mobile acrilice",
      },
    ],
  },
  {
    slug: "estetica-dentara",
    title: "Estetică dentară",
    short: "Albire profesională, fațete și restaurări estetice pentru un zâmbet armonios și natural.",
    image: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/0x3kdie4_file_00000000290871fd966e81db44d2d4dd.png",
    fit: "contain",
    icon: "sparkle",
    tone: "cream",
  },
  {
    slug: "tratamente-canal-radicular",
    title: "Tratamente de canal radicular",
    short: "Tratamente endodontice (de canal) efectuate sub anestezie, pentru conservarea dinților naturali, cu respectarea protocoalelor moderne.",
    image: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/24jw8jab_file_00000000fa5c71fd824f5b1882c7dbb0.png",
    fit: "contain",
    icon: "activity",
    tone: "yellow",
  },
  {
    slug: "ortodontie",
    title: "Ortodonție – în colaborare cu medicul ortodont",
    short: "Evaluarea inițială a anomaliilor dento-maxilare și îndrumare către medicul ortodont pentru planul de tratament. La copii, în cazuri selectate, pot fi indicate aparate funcționale de tip A.R.E. (Aparat de Reeducare Elastică) — decizia și supravegherea aparțin medicului ortodont.",
    image: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/blqv7ene_file_0000000081cc71f8925e0167a9a65fd5.png",
    fit: "contain",
    icon: "smile",
    tone: "green",
  },
  {
    slug: "consultatii-copii",
    title: "Consultații și tratamente stomatologice pentru copii",
    short: "Abordare blândă și prietenoasă, adaptată vârstei fiecărui copil: consultații, profilaxie și tratamente stomatologice uzuale, într-un cadru liniștitor.",
    image: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/a7nmlcp5_file_0000000079f871f8bac1188fec3a6867.png",
    fit: "contain",
    icon: "heart",
    tone: "pink",
  },
];
